import React, { useState } from 'react';
import { Form, Input, Button, Select, Row, Col, Space, Divider, DatePicker, InputNumber } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const { Option } = Select;
const { RangePicker } = DatePicker;

const Step3 = ({ value, onChange }) => {
  const [conditions, setConditions] = useState(value);
  
  const validateConditions = () => {
    return conditions.every(
      (condition) =>
        condition.property && condition.operator && (condition.value || condition.value === 0) // también considera valores como 0 válidos
    );
  };

  const addCondition = () => {
    setConditions([
      ...conditions,
      { property: '', operator: '', value: '', unit: '', logic: 'AND' },
    ]);
  };

  const removeCondition = (index) => {
    const newConditions = [...conditions];
    newConditions.splice(index, 1);
    setConditions(newConditions);
  };

  const handleChange = (index, field, value) => {
    const updatedConditions = [...conditions];
    updatedConditions[index][field] = value;

    if (field === 'operator') {
      updatedConditions[index].value = '';
      updatedConditions[index].unit = '';
    }

    setConditions(updatedConditions);
    onChange(updatedConditions); 
  };

  const renderValueInput = (condition, index) => {
    const { operator } = condition;

    if (operator === 'between') {
      return (
        <RangePicker
          style={{ width: '100%' }}
          onChange={(dates) => handleChange(index, 'value', dates)}
          value={condition.value}
        />
      );
    }

    if (operator === 'before' || operator === 'after') {
      return (
        <Space style={{ width: '100%' }}>
          <InputNumber
            style={{ width: '60%' }}
            placeholder="Cantidad"
            value={condition.value}
            onChange={(val) => handleChange(index, 'value', val)}
          />
          <Select
            style={{ width: '40%' }}
            placeholder="Unidad"
            value={condition.unit}
            onChange={(val) => handleChange(index, 'unit', val)}
          >
            <Option value="días">Días</Option>
            <Option value="semanas">Semanas</Option>
            <Option value="meses">Meses</Option>
            <Option value="años">Años</Option>
          </Select>
        </Space>
      );
    }

    // Default input
    return (
      <Input
        value={condition.value}
        onChange={(e) => handleChange(index, 'value', e.target.value)}
        placeholder="Valor"
      />
    );
  };

  return (
    <div>
      <div className='text-muted mb-2'>Establece las condiciones de la audiencia </div>
      <Form layout="vertical">
        {conditions.map((condition, index) => (
          <div key={index} style={{ marginBottom: 16, borderBottom: '1px solid #eee', paddingBottom: 12 }}>
            <Row gutter={[8, 8]} align="middle">
              {index > 0 && (
                <Col xs={24} sm={4}>
                  <Select
                    value={condition.logic}
                    onChange={(val) => handleChange(index, 'logic', val)}
                    placeholder="AND/OR"
                    style={{ width: '100%' }}
                  >
                    <Option value="AND">AND</Option>
                    <Option value="OR">OR</Option>
                  </Select>
                </Col>
              )}
              <Col xs={24} sm={5}>
                <Select
                  value={condition.property}
                  onChange={(val) => handleChange(index, 'property', val)}
                  placeholder="Propiedad"
                  style={{ width: '100%' }}
                >
                  <Option value="views">Vistas</Option>
                  <Option value="resencia">Resencia</Option>
                  <Option value="frequency">Frecuencia</Option>
                  <Option value="shockers">Choques</Option>
                  <Option value="experiences">Experiencias</Option>
                  <Option value="comportamiento">Comportamiento</Option>
                </Select>
              </Col>
              <Col xs={24} sm={5}>
                <Select
                  value={condition.operator}
                  onChange={(val) => handleChange(index, 'operator', val)}
                  placeholder="Operador"
                  style={{ width: '100%' }}
                >
                  <Option value="equals">Es igual</Option>
                  <Option value="not_equals">No es igual</Option>
                  <Option value="greater">Es mayor</Option>
                  <Option value="less">Es menor</Option>
                  <Option value="like">Se parece</Option>
                  <Option value="between">Está entre</Option>
                  <Option value="before">Antes de</Option>
                  <Option value="after">Después de</Option>
                </Select>
              </Col>
              <Col xs={24} sm={8}>
                {renderValueInput(condition, index)}
              </Col>
              <Col xs={24} sm={2}>
                <Button icon={<DeleteOutlined />} danger onClick={() => removeCondition(index)} />
              </Col>
            </Row>
          </div>
        ))}

        <Button icon={<PlusOutlined />} type="dashed" onClick={addCondition} style={{ marginBottom: 16 }}>
          Agregar condición
        </Button>
      </Form>      
    </div>
  );
};

export default Step3;
